import { BrowserTabTitle } from "@/components/shared/BrowserTabTitle"

import { getDashboardDisplayName } from "../widgets/utils/dashboardPageState"

/**
 * The dashboard page's one tab title: "Dashboard" until the open dashboard
 * loads, then "Dashboard > <name>". Every state of the page renders exactly one.
 */
export const DashboardTabTitle = ({
  dashboard,
}: {
  dashboard?: Parameters<typeof getDashboardDisplayName>[0]
}) => (
  <BrowserTabTitle type="Dashboard" name={getDashboardDisplayName(dashboard)} />
)
